import React from 'react';

import Button from 'components/Button';
import AgreementUserInfo from './components/AgreementUserInfo';
import './styles.css';

const KycNavigation = ({
  status,
  agreementUser,
  openVerifyKycModal,
  openKycDocumentUploadModal,
  openRequestKycDocumentModal
}) => (
  <div className="KycNavigation">
    <div className="UserInfo">
      <AgreementUserInfo agreementUser={agreementUser} status={status} />
    </div>
    <div className="KycButtons">
      <Button
        white
        className="kyc_Request_Document"
        onClick={openRequestKycDocumentModal}>
        Request Document
      </Button>
      <Button
        white
        className="kyc_Upload_Document"
        onClick={openKycDocumentUploadModal}>
        Upload Document
      </Button>
      <Button blue className="kyc_Verify_KYC" onClick={openVerifyKycModal}>
        Verify KYC
      </Button>
    </div>
  </div>
);

export default KycNavigation;
